import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12.5 13.5a1 1 0 000-2h-9a1 1 0 000 2h9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M11.51 11.305L13.333 4.5H7.5a1 1 0 000 2H11m.496-1.8l.7-2.612"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M4.5 12.5a1 1 0 11-2 0 1 1 0 012 0zm9 0a1 1 0 11-2 0 1 1 0 012 0z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 20.25a1.5 1.5 0 000-3H5.25a1.5 1.5 0 000 3h13.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.265 16.958L20 6.75h-8.75a1.5 1.5 0 000 3h5.25m.744-2.7l1.05-3.917"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 18.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zm13.5 0a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 40.5a3.001 3.001 0 000-6h-27a3.001 3.001 0 000 6h27z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.529 33.916l5.47-20.416h-17.5a3.001 3.001 0 000 6h10.5m1.489-5.398l2.1-7.836"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 37.5a3.001 3.001 0 01-6 0 3.001 3.001 0 016 0zm27 0a3.001 3.001 0 01-6 0 3.001 3.001 0 016 0z",
    clipRule: "evenodd"
  }))
};
export var Treadmill = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});